import { Button, Column, Columns, Container } from '@resurs/midas-react'
import { Conditional } from '@resurs/react-utils'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Page from '../../../internal/Page'
import { getText } from '../../../internal/TextLabels'
import { ChannelType } from '../../../models/channelType'
import { PaymentMethods } from '../../../models/payment-methods'
import {
  getTransactionDetails,
  clearTransactionDetails,
  getCreditTerminalTransaction,
} from '../../../store/actions/transactions-actions'
import { TransactionResultTypes } from '../../../util/transactionConstants'
import { getDeep } from '../../../util/helpers'
import { AdvancedTransactionDetailsUI, SimpleTransactionDetailsUI } from './UI'

const TransactionDetails = props => {
  const [channelType, setChannelType] = useState(
    getDeep(props.transactionDetails, 'channelType'),
  )
  const [paymentMethodType, setPaymentMethodType] = useState(
    getDeep(props.transactionDetails, 'paymentMethod.type'),
  )

  const onBack = () => {
    props.newRoute('transactions')
  }

  useEffect(() => {
    if (!props.transactionId && !props.transaction) {
      props.newRoute('transactions')
    }

    if (props.transactionId) {
      props.getTransactionDetails(props.transactionId)
    }
    if (props.transaction) {
      if (props.transaction.resultType !== TransactionResultTypes.PAYMENT) {
        props.getCreditTerminalTransaction(props.transaction)
      }
    }
    return () => {
      props.clearTransactionDetails()
    }
  }, [])

  useEffect(() => {
    setChannelType(getDeep(props.transactionDetails, 'channelType'))
    setPaymentMethodType(
      getDeep(props.transactionDetails, 'paymentMethod.type'),
    )
  })

  const getOrderLimit = () => {
    if (
      props.transactionDetails &&
      props.transactionDetails.application &&
      props.transactionDetails.application.approvedAmount
    ) {
      return props.transactionDetails.application.approvedAmount
    }
    if (
      props.transactionDetails &&
      props.transactionDetails.application &&
      props.transactionDetails.application.requestedAmount
    ) {
      return props.transactionDetails.application.requestedAmount
    }

    return 0
  }

  return (
    <div>
      <Container>
        <Columns>
          <Column col12>
            <Conditional.Group>
              <Conditional
                when={
                  !!(
                    channelType === ChannelType.ECOMMERCE ||
                    channelType === ChannelType.CHECKOUT_POS ||
                    channelType === ChannelType.MERCHANT_API ||
                    (channelType === ChannelType.MERCHANT_PORTAL &&
                      paymentMethodType === PaymentMethods.RESURS_INVOICE)
                  ) &&
                  props.transactionId &&
                  props.transactionDetails
                }
              >
                <AdvancedTransactionDetailsUI
                  orderLimit={getOrderLimit()}
                  transactionDetails={props.transactionDetails}
                  transaction={props.transaction}
                />
              </Conditional>
              <Conditional.NoMatch>
                <SimpleTransactionDetailsUI
                  onBack={() => props.newRoute('transactions')}
                  orderLimit={getOrderLimit()}
                  transactionDetails={props.transactionDetails}
                  transaction={props.transaction}
                />
              </Conditional.NoMatch>
            </Conditional.Group>
            <Page>
              <Column>
                <div
                  style={{
                    padding: '1.5rem 1rem 1.5rem 0',
                  }}
                >
                  <Button onClick={() => onBack()}>
                    {getText('default.back')}
                  </Button>
                </div>
              </Column>
            </Page>
          </Column>
        </Columns>
      </Container>
    </div>
  )
}

TransactionDetails.propTypes = {
  transactionId: PropTypes.string,
  transactionDetails: PropTypes.object,
  getTransactionDetails: PropTypes.func.isRequired,
  clearTransactionDetails: PropTypes.func.isRequired,
  getCreditTerminalTransaction: PropTypes.func.isRequired,
  newRoute: PropTypes.func.isRequired,
  transaction: PropTypes.object,
}

TransactionDetails.defaultProps = {
  transactionId: null,
  transactionDetails: null,
  transaction: null,
}

const mapStateToProps = state => {
  return {
    transactionDetails: state.transactions.currentTransactionDetails,
    transactionId: state.transactions.currentTransactionId,
    transaction: state.transactions.terminalTransactions.current,
  }
}

const mapDispatchToProps = dispatch => ({
  getTransactionDetails: transactionId => {
    dispatch(getTransactionDetails(transactionId))
  },
  getCreditTerminalTransaction: transaction => {
    dispatch(
      getCreditTerminalTransaction(
        transaction.accountNumber,
        transaction.transactionId,
      ),
    )
  },
  clearTransactionDetails: () => {
    dispatch(clearTransactionDetails())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(TransactionDetails)
